import { getAppConfigSetting, requests } from 'utils';
import { URL, ActionType } from './constants';


export function actionRequest(transferId: string, payload: string, actionType: ActionType) {
  return requests.put(`${URL(getAppConfigSetting('apiUrl'), transferId, actionType)}`, payload);
}



// WEBPACK FOOTER //
// ./src/services/actions/api.js